<div *ngIf="loading" class="custom-class">
  <div class="loader" id="loader"></div>
</div>
<div *ngIf="loadingServices.isLoading$ | async" class="custom-class">
  <div class="loader" id="loader"></div>
</div>

<router-outlet></router-outlet>

<!-- Popup -->
<div *ngIf="mostrarPopup" class="popup-overlay">
  <div class="popup" (click)="$event.stopPropagation()">
    <h2>Licencia no verificada</h2>
    <p>Debe cargar un archivo .license e ingresar la key para continuar</p>

    <!-- Botón para seleccionar archivo -->
    <label class="btn-secondary" for="fileInput">
      Seleccionar archivo
    </label>
    <input
      type="file"
      id="fileInput"
      style="display:none"
      (change)="onFileSelected($event)"
    />

    <!-- Mostrar nombre de archivo -->
    <p *ngIf="selectedFile">Archivo seleccionado: {{ selectedFile.name }}</p>

      <!-- Input key -->
    <input type="text" [(ngModel)]="licenseKey" placeholder="Ingrese la key" />

    <!-- Mensaje de error -->
    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>

    <!-- Botón enviar -->
    <button
      class="btn-primary"
      type="button"
      (click)="enviarLicencia()"
    >
      Enviar licencia y key
    </button>
  </div>
</div>